import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

export type OperationProps = {
  typeOperation: string;
  dateOperation: string;
  montantOperation: number;
};

export const RowOperation: FC<OperationProps> = ({ typeOperation, dateOperation, montantOperation }) => {
  const { t } = useTranslation();

  const formattedDate = new Date(dateOperation).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  const getOperationClassName = () => {
    if (typeOperation.includes('Arbitrage')) {
      return styles.amountOperationDefault;
    }
    if (montantOperation > 0) {
      return `${styles.amountOperationSuccess} ${styles.amountOperationDefault}`;
    }
    return `${styles.amountOperationError} ${styles.amountOperationDefault}`;
  };

  const getOperationPrefix = () => {
    if (typeOperation.includes('Arbitrage')) {
      return '';
    }
    if (montantOperation > 0) {
      return '+ ';
    }
    if (montantOperation < 0) {
      return '- ';
    }
    return ' ';
  };

  return (
    <>
      {montantOperation !== 0 && montantOperation !== null && (
        <tr className={styles.detailRow}>
          <td>
            <p className={styles.operationTypeLabel}> {typeOperation}</p>
            <p className={styles.operationDateLabel}> Le {formattedDate}</p>
          </td>

          <td>
            <p className={getOperationClassName()}>
              {' '}
              {getOperationPrefix()} {t('format.currencyFlexible', { value: Math.abs(montantOperation) })}{' '}
            </p>
          </td>
        </tr>
      )}
    </>
  );
};
